/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Spinner } from './Spinner';
export var BigSpinner = function (_a) {
    var className = _a.className;
    return (jsx("div", { sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
        }, className: className },
        jsx("div", null,
            jsx(Spinner, { size: "xl", sx: { color: 'dark' } }))));
};
//# sourceMappingURL=BigSpinner.js.map